export enum PlannerBoardActivityCardTextDisplayType {
    JUST_INPUT = 'JUST_INPUT',
    JUST_ACTIVITY_NAME = 'JUST_ACTIVITY_NAME',
    PREFIX_ACTIVITY_NAME_WITH_INPUT = 'PREFIX_ACTIVITY_NAME_WITH_INPUT',
    PREFIX_INPUT_WITH_ACTIVITY_NAME = 'PREFIX_INPUT_WITH_ACTIVITY_NAME'
}
